import React from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { storage } from "@/lib/storage";
import { authApi } from "@/lib/auth";

export const AccountCard = () => {
  const navigate = useNavigate();
  const user = storage.getUser();
  if (!user) return null;

  const logout = async () => {
    await authApi.logout();
    navigate("/", { replace: true });
  };

  return (
    <div className="card-glass rounded-2xl p-5 mb-6 flex items-center gap-4 fade-slide-up" data-testid="account-card">
      {user.picture ? (
        <img src={user.picture} alt="" className="w-12 h-12 rounded-full border gold-border" data-testid="account-avatar" />
      ) : (
        <div className="w-12 h-12 rounded-full bg-[rgba(230,180,85,0.12)] flex items-center justify-center text-[#E6B455] font-bold">
          {(user.name || user.email || "?")[0].toUpperCase()}
        </div>
      )}
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-[#F7E6B4] truncate" data-testid="account-name">{user.name}</div>
        <div className="text-xs text-[#F7E6B4]/55 truncate" data-testid="account-email">{user.email}</div>
      </div>
      <button
        onClick={logout}
        className="btn-outline-gold rounded-full px-4 py-2 text-xs font-semibold flex items-center gap-1.5"
        data-testid="logout-btn"
      >
        <LogOut size={14} /> Logout
      </button>
    </div>
  );
};
